module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"interviewsMonthly":"Собеседований в месяц","tariffTerms":"Выберите условия","creditCard":"Оплатить банковской картой","onAccount":"Оплатить по счету","candidateNotification":"Возможность оповестить кандидата","autoInformer":"Возможность оповещения через автоинформатор","offlineInterviewRecord":"Возможность записи оффлайн интервью","recommended":"Рекомендуемый тариф"}}')
  delete Component.options._Ctor
}
